/* global G */
import { asyncPipeSpread, getFirstItem } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { get, set } from 'lib/sequence/component/state/value'
import { hidden, show, hide } from 'lib/sequence/component/state/hidden'
import { disabled } from 'lib/sequence/component/state/disabled'
import { displayCustomerNumber, displaySupportedBy, presetCountries, presetProvides } from 'app/organisation/action/edit'
import listStatus from 'app/_shared/events/collection/listStatus'
import presetCountry from 'app/_shared/action/address/presetCountry'
import initAddress from 'app/_shared/action/address/init'
import displayState from 'app/_shared/events/address/displayState'
import displayHouseNumber from 'app/_shared/events/address/displayHouseNumber'

const display = x => (get(x) ? show(x) : hide(x))

const initOrganisationAddress = initAddress(
  { component: 'country' },
  {},
)

/**
 * Preset the `status` field.
 *
 * @param {Gaia.Component.Spec} module  the current module object composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const presetStatus = module => async (children, ...args) => {
  // component
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { status: statusField } = children

  const status = getFirstItem(listStatus(module, actionComponent, { detail: { key: 50 } }))

  // Only set the field if it's editable
  !hidden(statusField)
        && !disabled(statusField)
        && set(statusField, status)

  return [children, ...args]
}

export default module => component => async (...args) => asyncPipeSpread(
  displaySupportedBy(module),
  presetStatus(module),
  presetProvides(module),
  presetCountry(module),
  displayCustomerNumber(false)(module),
  initOrganisationAddress(
    displayState('state', 'country'),
    displayHouseNumber('number', 'street'),
  )(module),
  presetCountries(module),
)(find(component), ...args)
